import React, { useEffect, useMemo, useState } from "react";

const ProgressBar = ({ job }) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const safeSetProgress = useMemo(
    () => (value) => {
      const normalized = Math.max(0, Math.min(100, Number(value) || 0));
      setProgress(normalized);
      if (normalized > 0 && normalized < 100) {
        setIsVisible(true);
      }
    }, []
  );

  useEffect(() => {
    if (typeof job !== "function") {
      return undefined;
    }

    let mounted = true;
    let completeTimeout;
    let jobCleanup;

    const complete = () => {
      if (!mounted) return;
      safeSetProgress(100);
      completeTimeout = setTimeout(() => {
        if (!mounted) return;
        setIsVisible(false);
        setProgress(0);
      }, 250);
    };

    const runJob = async () => {
      setIsVisible(true);
      safeSetProgress(0);

      try {
        jobCleanup = await job({
          setProgress: safeSetProgress,
          complete,
        });
      } catch (error) {
        complete();
      }
    };

    runJob();

    return () => {
      mounted = false;
      if (completeTimeout) {
        clearTimeout(completeTimeout);
      }
      if (typeof jobCleanup === "function") {
        jobCleanup();
      }
    };
  }, [job, safeSetProgress]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed top-0 z-50 h-1 w-full bg-neutral-quaternary">
      <div className="h-full bg-brand bg-orange-500 transition-all duration-300" style={{ width: `${progress}%` }} />
    </div>
  );
};

export default ProgressBar;